import React, { useEffect, useState } from "react";
import { Row, Col, Card, Form, Spinner } from "react-bootstrap";
import Table from "../../components/Table";
import PageTitle from "../../components/PageTitle";
import ApiPagination from "../../components/ApiPagination";
import axios from "axios";

const TestOtps = () => {
  const [otps, setOtps] = useState([]);
  const [pagination, setPagination] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);

  const fetchOtps = async () => {
    setLoading(true);
    try {
      const res = await axios.get("/web/test-otps", {
        params: { page: currentPage, limit: 50 },
      });

      setOtps(res.data.data.testOtps || []);
      setPagination(res.data.data.pagination || null);
    } catch (error) {
      console.error(error);
    }

    setLoading(false);
    setInitialLoading(false);
  };

  useEffect(() => {
    fetchOtps();
  }, [currentPage]);

  const columns = [
    {
      Header: "Sl No",
      accessor: "",
      Cell: ({ row }: any) => {
        const currentPage = pagination?.currentPage || 1;
        const itemsPerPage = pagination?.itemsPerPage || 50;
        return <>{(currentPage - 1) * itemsPerPage + row.index + 1}</>;
      },
      sort: false,
    },
    { Header: "OTP", accessor: "otp", sort: false },
    { Header: "Mobile", accessor: "mobile", sort: false },
    {
      Header: "Created At",
      accessor: "created_at",
      sort: false,
      Cell: ({ value }: any) => {
        const date = new Date(value);
        return date.toLocaleString(); // readable format
      },
    },
  ];

  if (initialLoading || loading) {
    return <Spinner animation="border" style={{ position: "absolute", top: "50%", left: "50%" }} />;
  }

  return (
    <>
      <PageTitle
        breadCrumbItems={[
          { label: "Master", path: "", active: true },
          { label: "Test OTPs", path: "", active: true },
        ]}
        title="Test OTPs"
      />

      <Row>
        <Col>
          <Card className="bg-white">
            <Card.Body>
              <Table
                columns={columns}
                data={otps}
                pageSize={10}
                isSortable={false}
                pagination={false}
                isSearchable={false}
                theadClass="table-light mt-2"
              />

              {pagination?.totalItems > 0 && (
                <ApiPagination
                  currentPage={pagination.currentPage}
                  totalPages={pagination.totalPages}
                  totalItems={pagination.totalItems}
                  itemsPerPage={pagination.itemsPerPage}
                  hasNextPage={pagination.hasNextPage}
                  hasPreviousPage={pagination.hasPreviousPage}
                  onPageChange={(p) => setCurrentPage(p)}
                />
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default TestOtps;
